Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
EditableView = require 'app/scripts/views/internal/editable-view'
FormattingHelpView = require 'app/scripts/views/card/formatting-help-view'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
l = require 'app/scripts/lib/localize'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
template = require 'app/scripts/views/templates/description'
{ trackUe } = require '@trello/analytics'
{ Key } = require '@trello/keybindings'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = mixin AutoInsertionView, CompleterUtil, class DescriptionView extends EditableView

  initialize: ({ @board, @card, @maxDescLength, @placeholderKey }) ->
    super

    @hideFullDescription = @model.get('desc')?.length > @maxDescLength
    @descType = "#{@model.typeName.toLowerCase()} description"

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

    @makeDebouncedMethods 'render'

    @listenTo Layout, @getAutosaveEvent(), @onAutosaveEdit
    @listenTo @model, 'change:desc', @renderDebounced

  events:
    'click .js-edit-desc': 'editDesc'
    'click .js-format-help': 'openFormatHelp'
    'keyup .js-description-draft': 'keyAutoMention'
    'keyup .js-description-draft': (e) ->
      if e.key == Key.Escape
        @cancelEditDesc(e, 'by pressing escape key')
    'click .js-cancel-edit': (e) ->
      @cancelEditDesc(e, 'by clicking on cancel button')
    'click .js-desc-content.is-hide-full': ->
      @showFullDescription()
      trackUe(@descType, 'expands', 'description', '', '', '', { boardid: @board.id, cardid: @card?.id })

  render: ->
    data = {}
    data.editable = @model.editable()
    data.isCardDesc = @model.typeName == 'Card'
    data.placeholderKey = @placeholderKey
    data.templateModeEnabled =
      if data.isCardDesc
        @model.isOnBoardTemplate() && @templateFlagEnabled
      else
        @model.isTemplate() && @templateFlagEnabled

    @$el.html template(data)

    desc = @model.get('desc')

    descHtml = TFM.description.format(desc ? '', { textData: @model.get('descData') }).output
    $desc = @$('.js-desc')
    $desc.empty().append(descHtml).data('unmarkeddown', desc)
    $desc.find('p').attr('dir', 'auto')
    friendlyLinks $desc[0], @board

    hasDesc = !/^\s*$/.test(descHtml)
    @$('.js-show-with-desc').toggleClass('hide', !hasDesc)
    @$('.js-hide-with-desc').toggleClass('hide', hasDesc)

    descriptionDraft = @$('.js-description-draft').val()?.length > 0
    @$('.js-description-draft').addClass(@descType.split(' ').join('-'))
    @$('.js-hide-with-draft').toggleClass('hide', descriptionDraft)
    @$('.js-desc-content').toggleClass('is-hide-full', @hideFullDescription)

    @renderFormattingButton()
    @

  showFullDescription: ->
    @hideFullDescription = false
    @$('.js-desc-content').removeClass('is-hide-full')
    return

  editDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc')
    trackUe(@descType, 'enters', 'edit', '', '', 'by clicking on edit button', { boardid: @board.id, cardid: @card?.id })
    return

  cancelEditDesc: (e, method) ->
    trackUe(@descType, 'cancels', 'edit', '', '', method, { boardid: @board.id, cardid: @card?.id })
    @clearEdits(e)

  expandDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc', false)
    return

  renderFormattingButton: ->
    localizedText = l(['view title', 'formatting help'])
    # Wrap button with longer button text only on board sidebar, where there's less horizontal space
    wrapButton = @descType == 'board description' && localizedText.length > 20
    @$('.description-edit').toggleClass('long', wrapButton)
    @$('.description-edit .helper').toggleClass('long', wrapButton)

  openFormatHelp: (e) ->
    trackUe(@descType, 'opens', 'formatting help', '', '', '', { boardid: @board.id, cardid: @card?.id })
    PopOver.toggle
      elem: @$('.js-format-help')
      view: FormattingHelpView
      options: { @model, @modelCache }
      keepEdits: true
    false

  # Autosave

  getAutosaveEvent: ->
    return "autosave#{@model.typeName}Description"

  onAutosaveEdit: ($target) ->
    @hideFullDescription = false
    @commitEdits(null, $target)

  commitEdits: ->
    isEditing = @$('.description-title .editing').length
    if isEditing
      Auth.me().editing({ idBoard: @board.id })
      # Show 'Edit' button upon saving description
      @$('.description-title .editing').removeClass('editing')
      trackUe(@descType, 'saves', 'description', '', '', '', { boardid: @board.id, cardid: @card?.id })
      super

  # AutoMention

  getTextInput: ->
    descInput = @$('.js-description-draft:visible')
    if descInput.length
      return descInput

  getMentionTarget: ->
    descInput = @$('.js-description-draft:visible')
    if descInput.length
      return descInput[0]
